import { render, staticRenderFns } from "./CardChallengesRanking.vue?vue&type=template&id=e1f3daba&"
import script from "./CardChallengesRanking.vue?vue&type=script&lang=js&"
export * from "./CardChallengesRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports